import { AnswerCodeInput } from 'stores/TrainingAdminStoreAdapter';
import { AnswerCodeResult } from 'stores/TrainingAdminStoreAdapter';

import { EditableAnswerCode } from './AnswerCodesEditor';

const genId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

/**
 * 編集中の正解コードを API 入力形（fileId＋期待値の由来）に変換する。
 * 由来（sourceFileId + sourceSeq）を送り、arguments/stdout はバックエンドが実行履歴からコピーする。
 */
export const toAnswerCodeInputs = (answerCodes: EditableAnswerCode[]): AnswerCodeInput[] =>
  answerCodes.map((ac) => ({
    fileId: ac.fileId,
    expectedList: ac.expectedList.map((ex) => ({
      sourceFileId: ex.sourceFileId,
      sourceSeq: ex.sourceSeq,
    })),
  }));

/**
 * 設問詳細（API6314）の正解コードを編集フォーム用の形に変換する。
 * 由来（source_file_id / source_seq）が残っていればプレビュー再取得の目印にする。
 */
export const fromAnswerCodeResults = (results: AnswerCodeResult[]): EditableAnswerCode[] =>
  results.map((ac) => ({
    localId: genId(),
    fileId: ac.fileId,
    // 詳細レスポンスにファイル名がないため拡張子から簡易表示
    fileName: `${ac.extension} の正解コード`,
    // パスは詳細レスポンスに含まれないため空。knz 書き出し時に fileId → path を解決する。
    filePath: '',
    extension: ac.extension,
    expectedList: ac.expectedList.map((ex) => ({
      localId: genId(),
      sourceFileId: ex.sourceFileId ?? '',
      sourceSeq: ex.sourceSeq ?? -1,
      argumentsPreview: ex.arguments,
      stdoutPreview: ex.expectedStdout,
    })),
  }));

/** 設問成立バリデーション（正解コード1件以上・各正解コードに期待値1件以上・由来あり）。 */
export const validateAnswerCodes = (answerCodes: EditableAnswerCode[]): string | null => {
  if (answerCodes.length === 0) {
    return '正解コードを1つ以上追加してください';
  }
  for (const ac of answerCodes) {
    if (ac.expectedList.length === 0) {
      return `正解コード（${ac.extension}）に期待値を1つ以上追加してください`;
    }
    for (const ex of ac.expectedList) {
      if (!ex.sourceFileId || ex.sourceSeq < 0) {
        return `正解コード（${ac.extension}）の期待値に有効な実行履歴が指定されていません`;
      }
    }
  }
  return null;
};
